import type { SignInCompletedResponse, WebChannelAuthConfig } from '@repo/api/web/models'
import { defineStore } from 'pinia'
import { computed, reactive } from 'vue'

export type StateType = {
  _token: string | null
}

export const useAuthStore = defineStore('auth', () => {
  const _state = reactive<StateType>({
    _token: null,
  })

  const token = computed(() => _state._token)
  const config = ref<WebChannelAuthConfig>()
  const session = ref<SignInCompletedResponse>()

  function setToken(token: string | null) {
    _state._token = token
  }

  function reset() {
    setToken(null)
    setSession(undefined)
  }
  function setConfig(newConfig: WebChannelAuthConfig) {
    config.value = newConfig
  }
  function setSession(newSession?: SignInCompletedResponse) {
    session.value = newSession
  }

  return {
    _state,
    token,
    config,
    session,

    setSession,
    setToken,
    setConfig,
    reset,
  }
})
